export default __webpack_public_path__ + "static/kununu2x-92014a78bb39ba92e9168e62f25ff822.png";